<!-- Container-fluid starts-->
<div class="container-fluid" *ngIf="visible">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Channel List</h5>
                </div>
                <div class="card-body">
                    <div class="btn-popup pull-right">
                    </div>
                    <div class="custom-datatable">
                        <form class="row m-0">

                            <div class="mb-sm-4 col-3">
                                <label>User Name</label>
                                <input type='text' class="filter-ngx form-control" placeholder='User Name'
                                       [(ngModel)]="filterParams.username" (input)="applySearch()"
                                       autocomplete="off"/>
                            </div>
                            <div class="mb-sm-4 col-3">
                                <label>First Name</label>
                                <input type='text' class="filter-ngx form-control" placeholder='First Name'
                                       [(ngModel)]="filterParams.first_name" (input)="applySearch()"
                                       autocomplete="off"/>
                            </div>
                            <div class="mb-sm-4 col-3">
                                <label>Channel Name</label>
                                <input type='text' class="filter-ngx form-control" placeholder='Channel Name'
                                       [(ngModel)]="filterParams.channel_name" (input)="applySearch()"
                                       autocomplete="off"/>
                            </div>
                            <div class="mb-sm-4 col-3">
                                <label>Country Name</label>
                                <select class="form-select form-control" placeholder='Country'
                                        [(ngModel)]="filterParams.country_id" (change)="onSelect($event)">
                                    <option value="" [disabled]="true">Select Country</option>
                                    <option *ngFor="let item of countries"
                                            [ngValue]="item.country_id">{{item.country_name}}</option>
                                </select>
                            </div>

                            <div class="mb-sm-4 col-3 pt-1">
                                <button class="btn btn-primary me-1 mb-3 mt-3" (click)="clearFilter()">Clear</button>
                            </div>
                        </form>
1
                        <div class="clearfix"></div>
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th></th>
                                <th scope="col" sortable="id" (sort)="onSort($event)">Id</th>
                                <th scope="col" sortable="first_name" (sort)="onSort($event)">First Name</th>
                                <th scope="col" sortable="last_name" (sort)="onSort($event)">Last Name</th>
                                <th scope="col" sortable="username" (sort)="onSort($event)">User Name</th>
                                <th scope="col" sortable="channel_id" (sort)="onSort($event)">Channel Name</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let item of data| paginate: { itemsPerPage: 10, currentPage: currentPage, totalItems: total }">
                                <th><input type="checkbox" name="title_select" onclick="onSelect(item.id)"></th>
                                <th scope="row">{{ item.id }}</th>
                                <th scope="row">{{ item.first_name }}</th>
                                <th scope="row">{{ item.last_name }}</th>
                                <th scope="row">{{ item.username }}</th>
                                <th scope="row"><div  *ngIf="item.channels !=null">{{ item.channels.name }}</div></th>



                                <!-- <th scope="row"><a class="btn btn-primary" [routerLink]="['/pages/create-page/',item.channel_id]">Edit</a></th> -->
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="d-flex justify-content-center p-2">
                            <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->
